import { post } from '@tencent/pmd-network';

export function initQQChannelRouter(router) {
  // 判断是否为qq频道
  router.beforeEach((to, from, next) => {
    if (to.query && to.query.scene && to.query.scene === 'qqlive') {
      sessionStorage.setItem('key_scene', to.query.scene);
      sessionStorage.setItem('key_qq_channel_id', to.query.cid || '');
      next();
      // getChannelInfo(to.query.cid)
      //   .then((res) => {
      //     sessionStorage.setItem('key_qq_channel_name', res.name);
      //     sessionStorage.setItem('key_qq_channel_logo', res.icon);
      //     // 测试环境创建者和管理者有权限
      //     // 正式环境只有频道创建者有权限
      //     if (window.location.href.indexOf('https://h5-dev.nes.smoba.qq.com/') > -1) {
      //       sessionStorage.setItem('key_qq_channel_is_admin', [2, 4].includes(res.role) ? '1' : '');
      //     } else {
      //       sessionStorage.setItem('key_qq_channel_is_admin', [4].includes(res.role) ? '1' : '');
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   })
      //   .finally(() => {
      //     next();
      //   });
    } else {
      next();
    }
  });
}

export function getChannelInfo(channelId) {
  return new Promise((resolve, reject) => {
    const reqData = {
      qqchannel_id: String(channelId || ''),
    };
    post({
      url: '/pvpesport.sgamenes.commcgi.commcgi/QueryQQChannelDetail',
      reqData,
    })
      .then((response) => {
        const result = {
          name: '', // 频道名称
          icon: '', // 频道头像地址
          role: 0, // 用户角色 1:频道成员 2:频道管理员 4:频道创建者
        };
        if (response.r == 0) {
          result.name = response.name || '';
          result.icon = response.icon || '';
          result.role = response.role || 0;
        }
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function isQQChannel() {
  if (sessionStorage.getItem('key_scene') == 'qqlive') {
    return true;
  }
  return false;
}

export function qqChannelId() {
  if (sessionStorage.getItem('key_qq_channel_id')) {
    return sessionStorage.getItem('key_qq_channel_id');
  }
  return '';
}

export function qqChannelName() {
  if (sessionStorage.getItem('key_qq_channel_name')) {
    return sessionStorage.getItem('key_qq_channel_name');
  }
  return '';
}

export function qqChannelLogo() {
  if (sessionStorage.getItem('key_qq_channel_logo')) {
    return sessionStorage.getItem('key_qq_channel_logo');
  }
  return '';
}

export function isQQChannelAdmin() {
  if (sessionStorage.getItem('key_qq_channel_is_admin')) {
    return sessionStorage.getItem('key_qq_channel_is_admin') == '1';
  }
  return false;
}
